import { lazy } from 'react'
import { Route, Switch } from '@hfs/react-router'
import { getRoute } from '@hfs/website/utils/getRoute'

export const RoomsRoutes = () => (
  <Switch>
    <Route
      component={lazy(async () => {
        const { Room } = await import(
          /* webpackPrefetch: true, webpackChunkName: "Room" */ '@hfs/website/react/pages/public/Room'
        )

        return {
          default: Room,
        }
      })}
      path={getRoute('/rooms/:roomUuid')}
    />
    <Route
      component={lazy(async () => {
        const { Rooms } = await import(
          /* webpackPrefetch: true, webpackChunkName: "Rooms" */ '@hfs/website/react/pages/public/Rooms'
        )

        return {
          default: Rooms,
        }
      })}
      exact
      path={getRoute('/rooms')}
    />
  </Switch>
)
